import React, { useState, useEffect } from 'react';
import WebsiteServices from '../services/WebsiteServices';
import useAsync from '../hooks/useAsync';

function WebsiteContact() {
    const { data, error, isLoading } = useAsync(WebsiteServices.getWebsiteDetail);


    const [formValues, setFormValues] = useState({
        phone: '',
        email: '',
        address: '',
        description: '',
        aboutUs: '',
        youtube: '',
        findus: [''],
        print: '',
        faceBook: '',
        linkedin: '',
        instagram: '',
        twitter: '',
        aboutUsLong:'',
        android_apk_link:"",
        ios_apk_link:"",
        vendor_apk_link:"",
        android_apk_qr:null,
        ios_apk_qr:null,
        vendor_apk_qr:null
    });

    useEffect(() => {
        if (data?.data) {
            setFormValues({
                youtube: data.data.youtube || '',
                phone: data.data.phone || '',
                email: data.data.email || '',
               android_apk_link: data.data.android_apk_link || '',
ios_apk_link: data.data.ios_apk_link || '',
vendor_apk_link: data.data.vendor_apk_link || '',

                address: data.data.address || '',
                description: data.data.description || '',
                aboutUs: data.data.aboutUs || '',
                print: data.data.print || '',
                faceBook: data.data.faceBook || '',
                linkedin: data.data.linkedin || '',
                instagram: data.data.instagram || '',
                twitter: data.data.twitter || '',
                aboutUsLong: data.data.aboutUsLong || '',
                findus: data.data.findus || [''],
                  android_apk_qr: data.data.android_apk_qr || '',
            ios_apk_qr: data.data.ios_apk_qr || '',
            vendor_apk_qr: data.data.vendor_apk_qr || '',
            });
        }
    }, [data]);
const handleImageChange = (event) => {
    const { name, files } = event.target;

    if (files && files[0]) {
        const file = files[0];

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: file,
        }));
    }
};
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };
    const handleFindChange = (index, event) => {
        const updatedFind = formValues.findus.map((find, i) =>
            i === index ? event.target.value : find
        );
        setFormValues((prevValues) => ({ ...prevValues, findus: updatedFind }));
    };

    const addFind = () => {
        setFormValues((prevValues) => ({ ...prevValues, findus: [...prevValues.findus, ''] }));
    };

    const removeFind = (index) => {
        const updatedFind = formValues.findus.filter((_, i) => i !== index);
        setFormValues((prevValues) => ({ ...prevValues, findus: updatedFind }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {


                 const formData = new FormData();

        Object.keys(formValues).forEach((key) => {
            if (key === 'findus') {
                formData.append(key, JSON.stringify(formValues[key]));
            } else {
                formData.append(key, formValues[key]);
            }
        });
        
            await WebsiteServices.updateWebsiteDetail(data.data._id, formData);
            alert('Website details updated successfully');
        } catch (error) {
            console.error('Failed to update Website details', error);
            alert('Failed to update Website details');
        }
    };

    if (isLoading) {
        return <div className="loader design_loading">Loading...</div>;
    }

    if (error) {
        return <div>Error loading contact details</div>;
    }

    return (
        <div className="right_col" role="main">
             <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

<div className="my-auto">

  <h5 className="page-title fs-21 mb-1">Website Description</h5>
  <nav>

    <ol className="breadcrumb mb-0">

      <li className="breadcrumb-item">
        <a href="javascript:void(0);">Home</a>
      </li>
      <li className="breadcrumb-item active" aria-current="page">
       Description
      </li>
    </ol>
  </nav>
</div>
<div className="d-flex my-xl-auto right-content align-items-center">

  <div className="pe-1 mb-xl-0">

    <div className="sub-title-box-right d-flex">
 
    </div>
  </div>



</div>
</div>
          
            <div className="container-box">
                <div className="container-box-inner table-reponsive-tabe">
                    <div className="page-details">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="input-field">
                                        <label>Phone</label>
                                        <input
                                            type="text"
                                            name="phone"
                                            maxLength={10}
                                            className="form-control"
                                            value={formValues.phone}
                                            onChange={handleInputChange}
                                            
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="input-field">
                                        <label>email</label>
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control"
                                            value={formValues.email}
                                            onChange={handleInputChange}
                                            
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Address</label>
                                        <input
                                            type="text"
                                            name="address"
                                            className="form-control"
                                            value={formValues.address}
                                            onChange={handleInputChange}
                                            
                                        />
                                    </div>
                                </div>
                                
                                {/* <div className="col-lg-12">
                                    <div className="input-field">
                                        <label>Find Us</label>
                                        {formValues.findus.map((find, index) => (
                                            <div key={index} className="input-group mb-2">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={find}
                                                    onChange={(event) => handleFindChange(index, event)}
                                                    placeholder="Find Us"
                                            
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => removeFind(index)}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            className="btn btn-secondary mt-2"
                                            onClick={addFind}
                                        >
                                            + Add 
                                        </button>
                                    </div>
                                </div> */}

                                <div className=" col-lg-12">
                                    <div className="input-field">
                                        <label>About Short Description</label>
                                        <div className="input-link-outer">
                                            <textarea
                                                type="text"
                                                name="aboutUs"
                                                className="form-control"
                                                value={formValues.aboutUs}
                                                onChange={handleInputChange}
                                                
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className=" col-lg-12">
                                    <div className="input-field">
                                        <label>About Long Description</label>
                                        <div className="input-link-outer">
                                            <textarea
                                                type="text"
                                                name="aboutUsLong"
                                                className="form-control"
                                                value={formValues.aboutUsLong}
                                                onChange={handleInputChange}
                                                
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className=" col-lg-12">
                                    <div className="input-field">
                                        <label>Description</label>
                                        <div className="input-link-outer">
                                            <textarea
                                                type="text"
                                                name="description"
                                                className="form-control"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Facebook Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="faceBook"
                                                className="form-control"
                                                value={formValues.faceBook}
                                                onChange={handleInputChange}
                                                
                                            />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Instagram Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="instagram"
                                                className="form-control"
                                                value={formValues.instagram}
                                                onChange={handleInputChange}
                                                
                                            />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Print</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="print"
                                                className="form-control"
                                                value={formValues.print}
                                                onChange={handleInputChange}                                        
                                            />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Linkedin Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="linkedin"
                                                className="form-control"
                                                value={formValues.linkedin}
                                                onChange={handleInputChange}                                 
                                            />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Twitter Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="twitter"
                                                className="form-control"
                                                value={formValues.twitter}
                                                onChange={handleInputChange}                                               
                                            />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Youtube Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="youtube"
                                                className="form-control"
                                                value={formValues.youtube}
                                                onChange={handleInputChange}
                                             />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Android APK Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="android_apk_link"
                                                className="form-control"
                                                value={formValues.android_apk_link}
                                                onChange={handleInputChange}
                                             />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>IOS APK Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="ios_apk_link"
                                                className="form-control"
                                                value={formValues.ios_apk_link}
                                                onChange={handleInputChange}
                                             />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="input-field">
                                        <label>Vendor Apk Link</label>
                                        <div className="input-link-outer">
                                            <input
                                                type="text"
                                                name="vendor_apk_link"
                                                className="form-control"
                                                value={formValues.vendor_apk_link}
                                                onChange={handleInputChange}
                                             />
                                            <button type="button" className="link-copy-btn"><i className="fa fa-paperclip" /></button>
                                        </div>
                                    </div>
                                </div>


     <div className="col-sm-12">
    <div className="input-field">
        <label>Android APK QR</label>

        <input
            type="file"
            name="android_apk_qr"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
        />

        {formValues.android_apk_qr && (
            <div className="mt-3">
                <img
                  src={
    typeof formValues.android_apk_qr === "string"
        ? process.env.REACT_APP_URL + formValues.android_apk_qr
        : URL.createObjectURL(formValues.android_apk_qr)
}
                    //   src={process.env.REACT_APP_URL + android_apk_qr}
                    alt="Android QR"
                    width="150"
                    height="150"
                    style={{
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        padding: "5px",
                        borderRadius: "8px",
                    }}
                />
            </div>
        )}
    </div>
</div>
<div className="col-sm-12">
    <div className="input-field">
        <label>IOS APK QR</label>

        <input
            type="file"
            name="ios_apk_qr"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
        />

        {formValues.ios_apk_qr && (
            <div className="mt-3">
                <img
                  src={
    typeof formValues.ios_apk_qr === "string"
        ? process.env.REACT_APP_URL + formValues.ios_apk_qr
        : URL.createObjectURL(formValues.ios_apk_qr)
}
                    //  src={process.env.REACT_APP_URL + ios_apk_qr}
                    alt="IOS QR"
                    width="150"
                    height="150"
                    style={{
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        padding: "5px",
                        borderRadius: "8px",
                    }}
                />
            </div>
        )}
    </div>
</div>
<div className="col-sm-12">
    <div className="input-field">
        <label>Vendor APK QR</label>

        <input
            type="file"
            name="vendor_apk_qr"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
        />

        {formValues.vendor_apk_qr && (
            <div className="mt-3">
                <img
                  src={
    typeof formValues.vendor_apk_qr === "string"
        ? process.env.REACT_APP_URL + formValues.vendor_apk_qr
        : URL.createObjectURL(formValues.vendor_apk_qr)
}
                    //  src={process.env.REACT_APP_URL + vendor_apk_qr}
                    alt="Vendor QR"
                    width="150"
                    height="150"
                    style={{
                        objectFit: "contain",
                        border: "1px solid #ddd",
                        padding: "5px",
                        borderRadius: "8px",
                    }}
                />
            </div>
        )}
    </div>
</div>
                            </div>
                            <button type="submit" className="submit-green-btn">SUBMIT</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebsiteContact;
